// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1kcv7","colBig":"styles_colBig__HeJ2E","colSmall":"styles_colSmall__KjaNe"};